module.exports = __webpack_public_path__ + "img/bfa1495.png";